import { Component, OnInit } from '@angular/core';
import { ReportsServiceService } from '../../../../../services/reports-service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-view-instance-report',
  templateUrl: './view-instance-report.component.html',
  styleUrls: ['./view-instance-report.component.css']
})
export class ViewInstanceReportComponent implements OnInit {

  html: any;
  errorMessage = '';
  inscription: Subscription;
  instanceId: number;
  viewId: number;

  constructor(
    private reportsService: ReportsServiceService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.errorMessage = '';
    this.inscription = this.route.params.subscribe(params => {
      this.instanceId = params['instanceId'];
      this.viewId = params['viewId'];
      this.titleService.setTitle(`Visualização da Instância ${this.instanceId} através de um Layout `);
    });
    this.reportsService.getHtmlView(this.instanceId, this.viewId)
      .subscribe( response => {
        this.html = this.sanitizer.bypassSecurityTrustHtml(response.html);
        }, error1 => {
          console.log(error1);
          this.errorMessage = error1;
      });
  }

  downloadView() {
    this.errorMessage = '';
    this.reportsService.getPdfView(this.instanceId, this.viewId)
      .subscribe(data => {
          const fileName = `Instance_${this.instanceId}_View_${this.viewId}.pdf`;
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = encodeURIComponent(fileName);
          a.href = URL.createObjectURL(data);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
        },
        err => {
          this.errorMessage = err;
          console.log(err);
        }
      );
  }


}
